<template>
  <!-- 离职移交弹框组件 -->
  <div class="changeLizhi">
    <div class="tan-cont">
      <div class="tan-cont-top">交出清单： <span>
          <Checkbox class="tan-Checkbox"></Checkbox> 同时办理离职
        </span> </div>
      <ul class="tan-ul">
        <li>全部机构<h3>23个</h3>
        </li>
        <li>全部客户<h3>23个</h3>
        </li>
        <li>成交合同<h3>23个</h3>
        </li>
      </ul>
      <div class="tan-cont-bottom">
        选择接收人：
        <Input placeholder="搜索" class="tan-search" clearable>
        <Icon type="ios-search" slot="prefix" />
        </Input>
        <div class="tan-flex">
          <Tree class="tan-trees" :data="data4" @on-select-change="handleChange"></Tree>
          <Table class="tan-table" stripe @on-selection-change="selectionList" :columns="tancolumns4" :data="tandata1"></Table>
          <div class="tan-clear"></div>
        </div>
      </div>
      <div class="tan-cont-bottom">
        交接日期：
        <div class="tan-data">
          <DatePicker :editable="false" @on-change="changgeDatapicker" v-model="datapicker" type="date" placeholder="Select date" style="width: 200px"></DatePicker>

          <Button class="tan-data-btn" type="success" ghost @click="ok">确认移交</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'changeLizhi',
  data () {
    return {
      tandata1: [
        {
          name: 'John Brown',
        },
        {
          name: 'John Brownawdawdawd',
        },
      ],
      tancolumns4: [
        {
          title: '选中',
          align: 'center',
          key: 'checkBox',
          width: '60px',
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  'on-change': (e) => {
                    this.tandata1.forEach((items) => {      //先取消所有对象的勾选，checkBox设置为false
                      this.$set(items, 'checkBox', false)
                    });
                    this.tandata1[params.index].checkBox = e;  //再将勾选的对象的checkBox设置为true
                  }
                }
              })
            ])
          }
        },
        {
          title: '姓名',
          width: 120,
          align: 'center',
          key: 'userName',
          ellipsis: true
        }
      ],
      data4: [
        {
          title: 'parent 1',
          expand: true,
          children: [
            {
              title: 'parent 1-1',
              expand: false,
              children: [
                {
                  title: 'leaf 1-1-1',
                  expand: false,
                  children: [
                    {
                      title: 'leaf 1-1-1-1'
                    },
                    {
                      title: 'leaf 1-1-1=2'
                    }
                  ]

                },
                {
                  title: 'leaf 1-1-2'
                }
              ]
            },
            {
              title: 'parent 1-2',
              expand: false,
              children: [
                {
                  title: 'leaf 1-2-1'
                },
                {
                  title: 'leaf 1-2-1'
                }
              ]
            }
          ]
        }
      ],
      treeData: [],
      datapicker: '',

    }
  },
  methods: {
    ok () {
      this.$emit('lizhiSure', false)
    },
    cancel () {

    },
    selectionList (selection) {
    },
    handleChange (e) {
      if (e.length > 0) {
        Vue.set(e[0], 'selected', true)
        if (e[0].expand) {
          Vue.set(e[0], 'expand', false)
        }
        e[0].selected = true;
        e[0].expand = !e[0].expand;
        this.treeData = e;
      } else {
        e = this.treeData;
        if (e[0].expand) {
          Vue.set(e[0], 'expand', false)
        }
        Vue.set(e[0], 'selected', true)
        e[0].selected = true;
        e[0].expand = !e[0].expand;
      };
    },
    changgeDatapicker (a, b) { //日期
      this.datapicker = a;
    }
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
// 表格离职交接弹框
.ivu-modal {
  .tan-cont {
    max-height: 450px;
    overflow: hidden;
    overflow-y: scroll;
    font-size: 13px;
    padding-right: 5px;
    .tan-data {
      padding-top: 15px;
      .tan-data-btn {
        float: right;
      }
    }
    .tan-cont-top {
      width: 100%;
      margin-bottom: 15px;
      span {
        float: right;
      }
      .tan-Checkbox {
        margin-right: 10px;
      }
    }
    .tan-ul {
      display: block;
      width: 100%;
      height: 70px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      li {
        display: block;
        width: 130px;
        height: 55px;
        border: 1px dashed #53cac3;
        border-radius: 5px;
        text-align: center;
        padding-top: 5px;
        line-height: 20px;
      }
      li:last-child {
        margin-right: 0;
      }
    }
    .tan-cont-bottom {
      width: 100%;
      padding-left: 15px;
      padding-bottom: 20px;
      .tan-search {
        width: 100%;
        margin-top: 15px;
      }
      .tan-flex {
        width: 100%;
        margin-bottom: 20px;

        padding-top: 15px;
        .tan-trees {
          width: 55%;
          float: left;
        }
        .tan-table {
          float: right;
        }
        .tan-clear {
          clear: both;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tan/changeLizhi.vue